// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiHost: "http://officetest.ezekiahfrancis.org" // live server
  // apiHost: "http://localhost/bpm/api" // local server
  // apiHost: "http://192.168.29.117/bpm/api" // office server
  // apiHost: "http://192.168.1.10/bpm/api" // camp site server
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
